import React, { useEffect, useState } from "react";
import { Typography } from "@material-ui/core";
import "./SideNavbar.css";

export const SideNavbar = () => {
  const [activeNav, setActiveNav] = useState("#home");

  useEffect(() => {
    const sections = document.querySelectorAll("section");
    const observerOptions = {
      root: null,
      rootMargin: "0px",
      threshold: 0.3,
    };

    const observerCallback = (entries) => {
      const visibleSections = entries.filter((entry) => entry.isIntersecting);
      if (visibleSections.length > 0) {
        const mostVisible = visibleSections.reduce((prev, curr) =>
          prev.intersectionRatio > curr.intersectionRatio ? prev : curr
        );
        setActiveNav(`#${mostVisible.target.id}`);
      }
    };

    const observer = new IntersectionObserver(observerCallback, observerOptions);
    sections.forEach((section) => observer.observe(section));

    const handleScroll = () => {
      if (window.scrollY < 50) {
        setActiveNav("#home");
      }
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    window.addEventListener("touchmove", handleScroll, { passive: true });
    window.addEventListener("touchend", handleScroll);

    return () => {
      sections.forEach((section) => observer.unobserve(section));
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("touchmove", handleScroll);
      window.removeEventListener("touchend", handleScroll);
    };
  }, []);

  const handleNavClick = (e, target) => {
    e.preventDefault();
    const section = document.querySelector(target);
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <nav>
      <a
        href="#home"
        onClick={(e) => handleNavClick(e, "#home")}
        className={activeNav === "#home" ? "active" : ""}
      >
        <Typography>Home</Typography>
      </a>
      <a
        href="#about"
        onClick={(e) => handleNavClick(e, "#about")}
        className={activeNav === "#about" ? "active" : ""}
      >
        <Typography>About</Typography>
      </a>
      <a
        href="#works"
        onClick={(e) => handleNavClick(e, "#works")}
        className={activeNav === "#works" ? "active" : ""}
      >
        <Typography>Projects</Typography>
      </a>
      <a
        href="#contact"
        onClick={(e) => handleNavClick(e, "#contact")}
        className={activeNav === "#contact" ? "active" : ""}
      >
        <Typography>Contact</Typography>
      </a>
    </nav>
  );
};